import { render, staticRenderFns } from "./OTPInput.vue?vue&type=template&id=413f22c3&"
import script from "./OTPInput.vue?vue&type=script&lang=js&"
export * from "./OTPInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VOtpInput,VTooltip})
